module.exports = __webpack_public_path__ + "media/images/logos/horizontal-white-b545af022f892c72eaa1e7a4c8424af5.svg";